import React, { useState, useRef, useMemo, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import Toolbar from "devextreme/ui/toolbar";
import Schedule from "./Components/schedule";
import { getUsersName, getUserId, checkRoles } from "../../Utils/helper";
import useHandleSchedule from "../../Hooks/useHandleData/useHandleSchedule";
import useGetTimeoffByUserId from "../../Hooks/useGET/useGetTimeoffByUserId";
import useGetSupervisorsStudents from "../../Hooks/useGET/useGetSupervisorsStudents";
import useHandleHoursByUserId from "../../Hooks/useHandleData/useHandleHoursByUserId";
import useHandleBillingById from "../../Hooks/useHandleData/useHandleBillingById";
import ContextMenu from "./Components/contextMenu";
import Calender from "./Components/calendar";
import "./styles.css";
import HoursPopup from "./Components/hoursPopup";
import useGetHolidays from "../../Hooks/useGET/useGetHolidays";

/*
-=-=-=-=-=-=-=-=-=-=-=-= Calender Hours Page -=-=-=-=-=-=-=-=-=-=-=-=
=-=-=-=-=-=-=-= https://atlasboard.wsu-idp.org/users/uploads =-=-=-=-=-=-=-
*/

const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const cellClassName = ".dx-scheduler-date-table-cell";
const appointmentClassName = ".dx-scheduler-appointment";
const todaysDate = new Date(),
  dateCheck = new Date(Date.now() - 8 * 24 * 60 * 60 * 1000);

const isDateValid = (date, isOtherUser) => {
  if (date > todaysDate) return false;
  else if (date < dateCheck) {
    if (isOtherUser) return true;
    return false;
  }
  return true;
};
export default function ReportHoursPage({ props }) {
  const params = useParams(),
    usersName = getUsersName(),
    usersId = getUserId(),
    location = useLocation();

  const [selectedUser, setUser] = useState({
    id: props.user ? params.userId : getUserId(),
    name: props.user ? location.state.userName : getUsersName(),
  });
  const { usersHours, handleDelHours, handlePasteHours } =
    useHandleHoursByUserId(selectedUser.id);

  const [menuData, setMenuData] = useState({
      items: [],
      target: appointmentClassName,
    }),
    { scheduleData = [] } = useHandleSchedule(selectedUser.id),
    { allAprovedPto } = useGetTimeoffByUserId(selectedUser.id),
    { usersStudentsData = [], isLoading } = useGetSupervisorsStudents(usersId),
    [firstName, ...lastNameParts] = usersName.split(" "),
    lastName = lastNameParts.join(" "),
    dropDownData = useMemo(
      () => [
        ...[
          {
            firstName,
            lastName,
            id: usersId,
          },
        ],
        ...usersStudentsData,
      ],
      [firstName, lastName, usersId, usersStudentsData]
    );

  const isOtherUser = usersId !== selectedUser.id;

  const [selectedLocation, setLocation] = useState(1);
  const [selectedTask, setTask] = useState(0);
  const { billingAndWorkArr, billingType } = useHandleBillingById(
    selectedLocation,
    selectedTask
  );

  const copiedData = useRef(null);
  // const [target, setTarget] = useState(appointmentClassName)
  const [showPopup, setPopup] = useState({
    schedule: null,
    hours: null,
  });
  const { holiday } = useGetHolidays();
  const processedScheduleData = useMemo(() => {
    const scheduleObject = {};
    const hoursByDay = {};
    const allSchedulerData = usersHours?.concat(allAprovedPto);

    days.forEach((day, index) => {
      const slots = Array.isArray(scheduleData[index]?.employeeScheduleTime)
        ? scheduleData[index].employeeScheduleTime
        : [];

      let totalMs = 0;
      let minStart = null; // earliest start in the day
      let maxEnd = null; // latest end in the day

      for (const slot of slots) {
        const s = slot?.startTime ? new Date(slot.startTime) : null;
        const e = slot?.endTime ? new Date(slot.endTime) : null;
        if (!s || !e) continue;

        // track earliest/ latest hours
        if (!minStart || s < minStart) minStart = s;
        const endAdjusted =
          e < s ? new Date(e.getTime() + 24 * 60 * 60 * 1000) : e; // handle overnight
        if (!maxEnd || endAdjusted > maxEnd) maxEnd = endAdjusted;

        totalMs += endAdjusted - s;
      }

      // Expose “range” in hours like before
      const startHour = minStart ? minStart.getHours() : null;
      const endHour = maxEnd ? maxEnd.getHours() : null;

      // Total hours with minutes preserved
      const totalHours = totalMs / 3600000;

      scheduleObject[day] = { startHour, endHour, slotCount: slots.length };
      hoursByDay[day] = totalHours; // <- no rounding up, decimals kept
    });

    return { allSchedulerData, scheduleObject, hoursByDay };
  }, [usersHours, allAprovedPto, scheduleData]);

  const { allSchedulerData, scheduleObject, hoursByDay } =
    processedScheduleData;

  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };

  const handlePopup = useCallback((popupKey, data) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);

  /*
   ~=~=~ Renders colors in the scedulular ~=~=~
   | + 
   |
   */

  //const RenderWeekCell = useCallback((e) => {
  //    const { startDate, className, text, children } = e?.data;
  //    let cssClasses = className || null;
  //    const day = days[startDate.getDay()];
  //    const hours = startDate.getHours();
  //    const isWorking = hours >= scheduleObject[day].startShift && hours < scheduleObject[day].endShift

  //    const getPtoColor = (() => {
  //        let color = null;
  //        allPto?.forEach((pto) => {
  //            if (startDate >= new Date(pto?.ptoDates?.startDate) && startDate < new Date(pto?.ptoDates?.endDate)) {
  //                if (pto?.status === 1) {
  //                    color = ' status-approved'
  //                } else if (pto?.status === 0) {
  //                    color = ' status-in-review';
  //                }
  //            }
  //        });
  //        return color;
  //    });

  //    const ptoColor = getPtoColor();

  //    if (ptoColor) {
  //        cssClasses += ` ${ptoColor}`;
  //    } else if (isWorking && currentView !== 'month') {
  //        cssClasses += ' is-working';
  //    }

  //    return (
  //        <div className={cssClasses}>
  //            {currentView === 'month' ? text : children}
  //        </div>
  //    )
  //}, [currentView, allPto, scheduleObject]);

  const onStudentDropdownClick = useCallback((e) => {
    setUser({
      id: e.itemData.id,
      name: `${e.itemData.firstName} ${e.itemData.lastName}`,
    });
  }, []);

  const onContentReady = useCallback(
    async (e) => {
      let toolbarInstance = Toolbar.getInstance(
        e.element.querySelector(".dx-toolbar")
      );
      const scheduleButton = {
        widget: "dxButton",
        location: "after",
        options: {
          text: "Schedule",
          onClick: () => handlePopup("schedule"),
        },
      };

      const studentDropdown =
        !props.user && dropDownData.length > 1
          ? {
              widget: "dxDropDownButton",
              location: "after",
              options: {
                text: "Students",
                items: dropDownData,
                displayExpr: "firstName",
                onItemClick: onStudentDropdownClick,
              },
            }
          : {};

      if (toolbarInstance.option("items").length === 2) {
        let items = toolbarInstance.option("items");
        toolbarInstance.option("items", [
          items[0],
          scheduleButton,
          studentDropdown,
          items[1],
        ]);
      }
    },
    [dropDownData, handlePopup, onStudentDropdownClick, props.user]
  );

  const handleUpdateForm = useCallback(
    (appointmentData) => {
      const startDate = new Date(appointmentData.startDate);

      const formData = {
        id: appointmentData.id,
        startDate: startDate,
        totalHours: appointmentData.hours,
        billingAndWorkId: appointmentData.text,
        description: appointmentData.description,
        locationId: appointmentData.locationId,
        taskId: appointmentData.taskId,
        userId: selectedUser.id,
        projectId: appointmentData.projectId,
      };
      handlePopup("hours", { formData });
    },
    [handlePopup, selectedUser.id]
  );

  const handleNewForm = useCallback(
    (startDate) => {
      const formData = {
        startDate: startDate,
        userId: selectedUser.id,
      };

      handlePopup("hours", { formData });
    },
    [handlePopup, selectedUser.id]
  );

  const handleFormPaste = useCallback(
    async (startDate) => {
      await handlePasteHours(
        copiedData.current,
        billingAndWorkArr,
        startDate,
        selectedUser.id
      );
    },
    [handlePasteHours, selectedUser.id]
  );

  const handleAppointmentDelete = useCallback(
    async (id) => {
      await handleDelHours(id);
    },
    [handleDelHours]
  );

  const handleAppointmentContextMenu = useCallback(
    (event) => {
      event.event.preventDefault();

      const { appointmentData } = event;
      const isTimeOff = appointmentData.colorId === 2;

      const menuItems = [
        {
          disabled: isTimeOff,
          text: "Copy",
          icon: "copy",
          onItemClick: () => {
            copiedData.current = appointmentData;
            setLocation(appointmentData.locationId);
            setTask(appointmentData.taskId);
          },
        },
        {
          disabled:
            isTimeOff || !isDateValid(appointmentData.startDate, isOtherUser),
          text: "Edit",
          icon: "edit",
          onItemClick: () => handleUpdateForm(appointmentData),
        },
        {
          disabled: isTimeOff,
          text: "Delete",
          icon: "trash",
          onItemClick: () => handleAppointmentDelete(appointmentData.id),
        },
      ];

      setMenuData({
        items: menuItems,
        target: appointmentClassName,
      });
    },
    [handleAppointmentDelete, handleUpdateForm, isOtherUser]
  );

  const handleCellContextMenu = useCallback(
    (e) => {
      e.event.preventDefault();
      const isPasteDisabled =
        copiedData.current === null ||
        !isDateValid(e.cellData.startDate, isOtherUser);
      const name = !isPasteDisabled
        ? ": " +
          copiedData.current?.hours +
          " hours of " +
          copiedData.current?.text
        : "";
      //code to add up total hours for a specific day
      const clickDate = new Date(e.cellData.startDate).toLocaleDateString(
        "sv-SE"
      );
      let totalHours = usersHours
        ?.filter((x) => {
          if (new Date(x.startDate).toLocaleDateString("sv-SE") === clickDate) {
            return x;
          }
        })
        .map((x) => x.hours);
      let hours = totalHours.reduce((x, y) => x + y, 0);

      const menuItems = [
        {
          disabled: true,
          text: `${hours} hours`,
        },
        {
          disabled: isPasteDisabled,
          text: "Paste" + name,
          icon: "paste",
          onItemClick: () => handleFormPaste(e.cellData.startDate),
        },
      ];

      setMenuData({
        items: menuItems,
        target: cellClassName,
      });
    },
    [handleFormPaste, isOtherUser, usersHours]
  );

  return (
    <div className="page-content">
      <div className="calender-box contentBox">
        <h1 className="report-hours-name white">{`${selectedUser.name} Hour Report`}</h1>
        {showPopup.schedule && (
          <Schedule
            selectedUser={selectedUser}
            isOtherUser={isOtherUser}
            onClose={() => handleClose("schedule")}
          />
        )}
        {showPopup.hours && (
          <HoursPopup
            hoursData={showPopup.hours.data}
            userId={selectedUser.id}
            onClose={() => handleClose("hours")}
          />
        )}

        <ContextMenu items={menuData.items} target={menuData.target} />

        {!isLoading && (
          <Calender
            scedulerData={allSchedulerData}
            holiday={holiday}
            isOtherUser={isOtherUser}
            handleUpdateForm={handleUpdateForm}
            handleNewForm={handleNewForm}
            /* RenderWeekCell={RenderWeekCell}*/
            onContentReady={onContentReady}
            handleCellContextMenu={handleCellContextMenu}
            handleAppointmentContextMenu={handleAppointmentContextMenu}
            userId={selectedUser.id}
            hoursByDay={hoursByDay}
          />
        )}
      </div>
    </div>
  );
}
